import "@fontsource/staatliches"
import "@fontsource/inter"
import "@fontsource/vt323"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAnglesLeft, faAnglesRight, faGlobe, faRocket, faCompassDrafting, faDatabase, faCode, faDiamond, faBars, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faYoutube, faLinkedinIn, faGithub, faInstagram, faTwitter, faSearchengin } from '@fortawesome/free-brands-svg-icons'

library.add(faYoutube);
library.add(faLinkedinIn);
library.add(faGithub);
library.add(faInstagram);
library.add(faTwitter);
library.add(faAnglesRight);
library.add(faAnglesLeft);
library.add(faGlobe);
library.add(faRocket);
library.add(faSearchengin);
library.add(faCompassDrafting);
library.add(faDatabase);
library.add(faCode);
library.add(faDiamond);
library.add(faBars);
library.add(faEnvelope);